import { startOfToday } from "date-fns/startOfToday";
import { endOfToday } from "date-fns/endOfToday";

export interface TenaxTask {
  id: number;
  text: string;
  status: string;
  due_date: string | null;
  sales_id: number | null;
  area_id: number | null;
  priority: number;
  // who the task is about, from today_items (D-045): "Mario Rossi · Maestri"
  about?: string | null;
}

// Open tasks by due date; internal tasks may have none.
export const groupOpenTasks = (tasks: TenaxTask[]) => {
  const today = startOfToday();
  const endToday = endOfToday();
  return {
    overdue: tasks.filter((t) => t.due_date && new Date(t.due_date) < today),
    today: tasks.filter(
      (t) =>
        t.due_date &&
        new Date(t.due_date) >= today &&
        new Date(t.due_date) < endToday,
    ),
    upcoming: tasks.filter(
      (t) => t.due_date && new Date(t.due_date) >= endToday,
    ),
    no_date: tasks.filter((t) => !t.due_date),
  };
};
